import type { SplitsErrors } from './errors';
import type { SplitsFields, SplitsState, SplitsTouchedFields } from './schema';

export function initialSplitsErrors() {
  return {
    splits: null,
  } satisfies SplitsErrors;
}

export function initialSplitsTouchedFields() {
  return {
    splits: false,
  } satisfies SplitsTouchedFields;
}

export function initialSplitsFields() {
  return {
    splitContractAddress: null,
    splits: [],
  } satisfies SplitsFields;
}

export function splitsInitialState() {
  return {
    errors: initialSplitsErrors(),
    fields: initialSplitsFields(),
    touched: initialSplitsTouchedFields(),
    isValid: false,
  } satisfies SplitsState;
}
